import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import Invoices from './pages/Invoices';
import InvoicePreview from './pages/InvoicePreview';
import Expenses from './pages/Expenses';
import Customers from './pages/Customers';
import Vendors from './pages/Vendors';
import Reports from './pages/Reports';
import TaxReport from './pages/TaxReport';
import AdminDashboard from './pages/AdminDashboard';
import PrivateRoute from './components/PrivateRoute';
import Settings from './pages/Settings';
import Estimates from './pages/Estimates';
import Projects from './pages/Projects';
import Profile from './pages/Profile';

function App() {
  const handleLogin = (t) => {
    localStorage.setItem('token', t);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="/register" element={<Register onRegister={handleLogin} />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/" element={<PrivateRoute component={Dashboard} />} />
          <Route path="/dashboard" element={<PrivateRoute component={Dashboard} />} />
          <Route path="/invoices" element={<PrivateRoute component={Invoices} />} />
          <Route path="/invoices/:id/preview" element={<PrivateRoute component={InvoicePreview} />} />
          <Route path="/expenses" element={<PrivateRoute component={Expenses} />} />
          <Route path="/customers" element={<PrivateRoute component={Customers} />} />
          <Route path="/vendors" element={<PrivateRoute component={Vendors} />} />
          <Route path="/reports" element={<PrivateRoute component={Reports} />} />
          <Route path="/tax-report" element={<PrivateRoute component={TaxReport} />} />
          <Route path="/admin-dashboard" element={<PrivateRoute component={AdminDashboard} requiredRole="admin" />} />
          <Route path="/settings" element={<PrivateRoute component={Settings} />} />
          <Route path="/estimates" element={<PrivateRoute component={Estimates} />} />
          <Route path="/projects" element={<PrivateRoute component={Projects} />} />
          <Route path="/profile" element={<PrivateRoute component={Profile} />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
